/* eslint-disable */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'

export const EventBus = new Vue();

Vue.component("axios", Axios)


// Bootstrap
import BootstrapVue from 'bootstrap-vue'
Vue.use(BootstrapVue)
import './bootstrap-override.scss'
import '@/styles/main.scss'

//i18n
import i18n from './i18n'

//scrolling to anchors
import VueScrollTo from 'vue-scrollto'
Vue.use(VueScrollTo)

// Scrollmagic
import VueScrollmagic from 'vue-scrollmagic'
Vue.use(VueScrollmagic)


// AOS (animate on scroll)
import 'fullpage.js/vendors/scrolloverflow' // Optional. When using scrollOverflow:true
import './fullpage.scrollHorizontally.min' // Optional. When using fullpage extensions
import VueFullPage from 'vue-fullpage.js'
Vue.use(VueFullPage);

Vue.config.productionTip = false



new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')

